// Pages that must render without an Auth0 session, so auth middleware skips them.
export const authExemptRoutes = ['/logout', '/open-in-browser', '/continue-sign-in'];

// Pages never saved as the post-login destination.
export const uncachedRoutes = ['/check-email', '/legal', '/logout'];
